// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export const foundationStates = ['formed', 'pre-formation'];
